export type PropertyType = 'apartment' | 'villa' | 'office' | 'land' | 'chalet' | 'warehouse';
export type ListingMode = 'sale' | 'rent';
export type PropertyStatus = 'published' | 'featured' | 'expired';

export interface Property {
  id: string;
  title: string;
  type: PropertyType;
  mode: ListingMode;
  price: number;
  priceUnit: 'AED' | 'AED/شهر' | 'AED/سنة';
  area: number;
  bedrooms: number | null;
  bathrooms: number | null;
  floor: number | null;
  city: string;
  district: string;
  furnished: boolean;
  verified: boolean;
  status: PropertyStatus;
  views: number;
  unlocks: number;
  listedAt: string;
  image: string;
  imageAlt: string;
  ownerName: string;
}

export const MOCK_PROPERTIES: Property[] = [
{
  id: 'prop-001',
  title: 'شقة فاخرة في دبي مارينا مع إطلالة على البحر',
  type: 'apartment',
  mode: 'rent',
  price: 9500,
  priceUnit: 'AED/شهر',
  area: 145,
  bedrooms: 3,
  bathrooms: 2,
  floor: 15,
  city: 'دبي',
  district: 'دبي مارينا',
  furnished: true,
  verified: true,
  status: 'featured',
  views: 312,
  unlocks: 18,
  listedAt: '2026-04-02',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_110beb963-1774897481161.png",
  imageAlt: 'شقة حديثة بغرفة معيشة مفتوحة وإضاءة طبيعية مع إطلالة على البحر',
  ownerName: 'أحمد المنصوري'
},
{
  id: 'prop-002',
  title: 'فيلا مستقلة 5 غرف مع مسبح خاص — جزيرة السعديات',
  type: 'villa',
  mode: 'sale',
  price: 5800000,
  priceUnit: 'AED',
  area: 520,
  bedrooms: 5,
  bathrooms: 6,
  floor: null,
  city: 'أبوظبي',
  district: 'جزيرة السعديات',
  furnished: false,
  verified: true,
  status: 'published',
  views: 874,
  unlocks: 42,
  listedAt: '2026-03-28',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_17f167eca-1772191565057.png",
  imageAlt: 'فيلا فاخرة بواجهة حجرية ومسبح خارجي في النهار',
  ownerName: 'سلطان الكعبي'
},
{
  id: 'prop-003',
  title: 'مكتب تجاري في برج خليفة — الدور 30',
  type: 'office',
  mode: 'rent',
  price: 28000,
  priceUnit: 'AED/شهر',
  area: 220,
  bedrooms: null,
  bathrooms: 2,
  floor: 30,
  city: 'دبي',
  district: 'وسط مدينة دبي',
  furnished: true,
  verified: true,
  status: 'published',
  views: 198,
  unlocks: 9,
  listedAt: '2026-04-01',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15da1dd8d-1773176909130.png",
  imageAlt: 'مكتب عصري بنوافذ زجاجية كبيرة وإطلالة على برج خليفة',
  ownerName: 'نورة الهاشمي'
},
{
  id: 'prop-004',
  title: 'أرض سكنية في مدينة محمد بن زايد — مساحة 600 م²',
  type: 'land',
  mode: 'sale',
  price: 1200000,
  priceUnit: 'AED',
  area: 600,
  bedrooms: null,
  bathrooms: null,
  floor: null,
  city: 'أبوظبي',
  district: 'مدينة محمد بن زايد',
  furnished: false,
  verified: false,
  status: 'published',
  views: 143,
  unlocks: 5,
  listedAt: '2026-04-03',
  image: "https://images.unsplash.com/photo-1621017470037-449f2e60f4b2",
  imageAlt: 'قطعة أرض فضاء في منطقة سكنية هادئة خلال الغروب',
  ownerName: 'فهد الظاهري'
},
{
  id: 'prop-005',
  title: 'شقة غرفتين قريبة من جامعة الشارقة',
  type: 'apartment',
  mode: 'rent',
  price: 4800,
  priceUnit: 'AED/شهر',
  area: 95,
  bedrooms: 2,
  bathrooms: 1,
  floor: 2,
  city: 'الشارقة',
  district: 'حي الجامعة',
  furnished: false,
  verified: false,
  status: 'published',
  views: 267,
  unlocks: 22,
  listedAt: '2026-04-04',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bbd197c1-1772306281734.png",
  imageAlt: 'شقة صغيرة مرتبة بغرفة نوم وصالة مفروشة',
  ownerName: 'ريم الشامسي'
},
{
  id: 'prop-006',
  title: 'شاليه على شاطئ الجميرا — تأجير أسبوعي وشهري',
  type: 'chalet',
  mode: 'rent',
  price: 18500,
  priceUnit: 'AED/شهر',
  area: 310,
  bedrooms: 4,
  bathrooms: 3,
  floor: null,
  city: 'دبي',
  district: 'شاطئ الجميرا',
  furnished: true,
  verified: true,
  status: 'featured',
  views: 651,
  unlocks: 37,
  listedAt: '2026-03-25',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1ac72d1-1772891071298.png",
  imageAlt: 'شاليه فاخر بمسبح خارجي مطل على البحر الأزرق',
  ownerName: 'خالد الزعابي'
},
{
  id: 'prop-007',
  title: 'فيلا دوبلكس في نخلة جميرا — تشطيب سوبر لوكس',
  type: 'villa',
  mode: 'sale',
  price: 12500000,
  priceUnit: 'AED',
  area: 680,
  bedrooms: 6,
  bathrooms: 7,
  floor: null,
  city: 'دبي',
  district: 'نخلة جميرا',
  furnished: false,
  verified: true,
  status: 'published',
  views: 1023,
  unlocks: 61,
  listedAt: '2026-03-20',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13dc422ac-1772210226514.png",
  imageAlt: 'فيلا دوبلكس فخمة بواجهة بيضاء وحديقة خضراء على نخلة جميرا',
  ownerName: 'عبدالله النعيمي'
},
{
  id: 'prop-008',
  title: 'مستودع تجاري 800 م² في المنطقة الصناعية جبل علي',
  type: 'warehouse',
  mode: 'rent',
  price: 35000,
  priceUnit: 'AED/شهر',
  area: 800,
  bedrooms: null,
  bathrooms: 1,
  floor: null,
  city: 'دبي',
  district: 'جبل علي',
  furnished: false,
  verified: true,
  status: 'published',
  views: 89,
  unlocks: 4,
  listedAt: '2026-04-03',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13a406f0d-1773500582421.png",
  imageAlt: 'مستودع واسع بأبواب معدنية كبيرة في منطقة صناعية',
  ownerName: 'ماجد الرميثي'
},
{
  id: 'prop-009',
  title: 'شقة استوديو مفروشة في وسط دبي',
  type: 'apartment',
  mode: 'rent',
  price: 5500,
  priceUnit: 'AED/شهر',
  area: 60,
  bedrooms: 1,
  bathrooms: 1,
  floor: 3,
  city: 'دبي',
  district: 'بر دبي',
  furnished: true,
  verified: false,
  status: 'published',
  views: 445,
  unlocks: 31,
  listedAt: '2026-04-04',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1537bedaf-1770926755216.png",
  imageAlt: 'استوديو أنيق بتصميم مفتوح ومطبخ حديث في دبي',
  ownerName: 'سارة الفلاسي'
},
{
  id: 'prop-010',
  title: 'فيلا للبيع — عجمان — 4 غرف نوم',
  type: 'villa',
  mode: 'sale',
  price: 1950000,
  priceUnit: 'AED',
  area: 380,
  bedrooms: 4,
  bathrooms: 5,
  floor: null,
  city: 'عجمان',
  district: 'الزاهية',
  furnished: false,
  verified: true,
  status: 'published',
  views: 567,
  unlocks: 28,
  listedAt: '2026-03-30',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14b234be1-1772210223404.png",
  imageAlt: 'فيلا عصرية بتصميم معماري أنيق ومدخل رئيسي واسع في عجمان',
  ownerName: 'محمد الجسمي'
},
{
  id: 'prop-011',
  title: 'محل تجاري في دبي مول — 80 م²',
  type: 'office',
  mode: 'rent',
  price: 55000,
  priceUnit: 'AED/شهر',
  area: 80,
  bedrooms: null,
  bathrooms: 1,
  floor: 1,
  city: 'دبي',
  district: 'وسط مدينة دبي',
  furnished: false,
  verified: true,
  status: 'published',
  views: 203,
  unlocks: 14,
  listedAt: '2026-04-01',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13eb06e92-1767660539383.png",
  imageAlt: 'محل تجاري بواجهة زجاجية في مركز تجاري حديث بدبي',
  ownerName: 'لمياء الكندي'
},
{
  id: 'prop-012',
  title: 'شقة 4 غرف في مشروع رسيدنس — الريم آيلاند',
  type: 'apartment',
  mode: 'sale',
  price: 2200000,
  priceUnit: 'AED',
  area: 185,
  bedrooms: 4,
  bathrooms: 3,
  floor: 8,
  city: 'أبوظبي',
  district: 'جزيرة الريم',
  furnished: false,
  verified: true,
  status: 'published',
  views: 389,
  unlocks: 19,
  listedAt: '2026-04-02',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b477bb8-1772210228680.png",
  imageAlt: 'شقة فسيحة بنوافذ بانورامية وإطلالة على جزيرة الريم في أبوظبي',
  ownerName: 'عمر الحمادي'
}];


export const CITIES = ['الكل', 'دبي', 'أبوظبي', 'الشارقة', 'عجمان', 'رأس الخيمة', 'الفجيرة'];
export const PROPERTY_TYPES = [
{ value: 'all', label: 'الكل' },
{ value: 'apartment', label: 'شقة' },
{ value: 'villa', label: 'فيلا' },
{ value: 'office', label: 'مكتب / محل' },
{ value: 'land', label: 'أرض' },
{ value: 'chalet', label: 'شاليه' },
{ value: 'warehouse', label: 'مستودع' }];


export const TYPE_LABELS: Record<PropertyType, string> = {
  apartment: 'شقة',
  villa: 'فيلا',
  office: 'مكتب',
  land: 'أرض',
  chalet: 'شاليه',
  warehouse: 'مستودع'
};

export function formatPrice(price: number, unit: string): string {
  if (price >= 1000000) {
    return `${(price / 1000000).toFixed(2)} م ${unit}`;
  }
  if (price >= 1000) {
    return `${(price / 1000).toFixed(0)}ك ${unit}`;
  }
  return `${price.toLocaleString('ar-AE')} ${unit}`;
}